import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

const EmailInputComponent = ({ emailInput = {} }) => {
  const { hoveredDivision, files } = useContext(CanvasContext);

  const isHovered = emailInput.id === hoveredDivision;
  const [isDivHovered, setIsDivHovered] = useState(false);
  const [isDivFocused, setIsDivFocused] = useState(false);
  const [isDivActive, setIsDivActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);
  const [backgroundImagelabelUrl, setlabelbackgroundImagelabelUrl] =
    useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = emailInput;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const labelconstructGradientString = () => {
    const {
      labelbackgroundGradientImage,
      labelgradientDirection,
      labelgradientShape,
      labelgradientPosition,
      labelstartColor,
      labelendColor,
      labelgradientAngle,
      labelpatternLength,
    } = emailInput;

    switch (labelbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${labelgradientDirection || "to right"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${labelgradientShape || "circle"} at ${
          labelgradientPosition || "center"
        }, ${labelstartColor || "#ff7e5f"}, ${labelendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${labelgradientAngle || "45"}deg, ${
          labelstartColor || "#606dbc"
        }, ${labelendColor || "#465298"} ${labelpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          labelgradientShape || "circle"
        } at ${labelgradientPosition || "center"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"} ${labelpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = emailInput;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = emailInput;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = emailInput;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (
        emailInput.backgroundImage &&
        emailInput.backgroundImage.startsWith("./")
      ) {
        const imageName = emailInput.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(emailInput.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [emailInput.backgroundImage, files]);

  useEffect(() => {
    const fetchlabelbackgroundImagelabel = async () => {
      if (
        emailInput.labelbackgroundImagelabel &&
        emailInput.labelbackgroundImagelabel.startsWith("./")
      ) {
        const imageName = emailInput.labelbackgroundImagelabel.replace(
          "./",
          ""
        );
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setlabelbackgroundImagelabelUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setlabelbackgroundImagelabelUrl(emailInput.labelbackgroundImagelabel);
      }
    };

    fetchlabelbackgroundImagelabel();
  }, [emailInput.labelbackgroundImagelabel, files]);

  const focusedStyles =
    isDivFocused && emailInput.pseudoClass === "focus"
      ? {
          width: emailInput.focusedwidth || emailInput.width || "200px",
          height: emailInput.focusedheight || emailInput.height || "auto",

          padding: emailInput.focusedpadding || emailInput.padding || "0",
          paddingTop:
            emailInput.focusedpaddingTop || emailInput.focusedpadding || "0",
          paddingRight:
            emailInput.focusedpaddingRight || emailInput.focusedpadding || "0",
          paddingBottom:
            emailInput.focusedpaddingBottom || emailInput.focusedpadding || "0",
          paddingLeft:
            emailInput.focusedpaddingLeft || emailInput.focusedpadding || "0",
          margin: emailInput.focusedmargin || emailInput.margin || "0px",
          marginTop:
            emailInput.focusedmarginTop || emailInput.focusedmargin || "0px",
          marginRight:
            emailInput.focusedmarginRight || emailInput.focusedmargin || "0px",
          marginBottom:
            emailInput.focusedmarginBottom || emailInput.focusedmargin || "0px",
          marginLeft:
            emailInput.focusedmarginLeft || emailInput.focusedmargin || "10px",

          borderTop:
            emailInput.focusedborderTop ||
            emailInput.focusedborder ||
            emailInput.border ||
            "1px solid #000000",
          borderRight:
            emailInput.focusedborderRight ||
            emailInput.focusedborder ||
            emailInput.border ||
            "1px solid #000000",
          borderBottom:
            emailInput.focusedborderBottom ||
            emailInput.focusedborder ||
            emailInput.border ||
            "1px solid #000000",
          borderLeft:
            emailInput.focusedborderLeft ||
            emailInput.focusedborder ||
            emailInput.border ||
            "1px solid #000000",
          borderSapcing:
            emailInput.focusedborderSpacing ||
            emailInput.borderSpacing ||
            "0px",
          borderCollapse:
            emailInput.focusedborderCollapse ||
            emailInput.borderCollapse ||
            "0px",
          borderRadius:
            emailInput.focusedborderRadius || emailInput.borderRadius || "0",
          outline: emailInput.focusedoutline || emailInput.outline || "none",

          position:
            emailInput.focusedposition || emailInput.position || "relative",
          top: emailInput.focusedtop || emailInput.top || "auto",
          right: emailInput.focusedright || emailInput.right || "auto",
          bottom: emailInput.focusedbottom || emailInput.bottom || "auto",
          left: emailInput.focusedleft || emailInput.left || "auto",
          zIndex: emailInput.focusedzIndex || emailInput.zIndex || "auto",

          color: emailInput.focusedcolor || emailInput.color || "#000000",
          backgroundColor:
            emailInput.focusedbackgroundColor ||
            emailInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (emailInput.focusedbackgroundImage) {
              if (emailInput.focusedbackgroundImage.startsWith("./")) {
                const imageName = emailInput.focusedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${emailInput.focusedbackgroundImage})`;
            }
            if (emailInput.backgroundImage) {
              if (emailInput.backgroundImage.startsWith("./")) {
                const imageName = emailInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${emailInput.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            emailInput.focusedbackgroundPosition ||
            emailInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            emailInput.focusedbackgroundSize ||
            emailInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            emailInput.focusedbackgroundRepeat ||
            emailInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            emailInput.focusedbackgroundAttachment ||
            emailInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            emailInput.focusedboxShadow || emailInput.boxShadow || "none",
          opacity: emailInput.focusedOpacity || emailInput.opacity || 1,
          display: emailInput.focuseddisplay || emailInput.display || "inline",

          fontFamily:
            emailInput.focusedfontFamily || emailInput.fontFamily || "inherit",
          fontSize:
            emailInput.focusedfontSize || emailInput.fontSize || "inherit",
          fontWeight:
            emailInput.focusedfontWeight || emailInput.fontWeight || "normal",
          fontStyle:
            emailInput.focusedfontStyle || emailInput.fontStyle || "normal",
          fontVariant:
            emailInput.focusedfontVariant || emailInput.fontVariant || "normal",
          lineHeight:
            emailInput.focusedlineHeight || emailInput.lineHeight || "normal",
          textShadow:
            emailInput.focusedtextShadow || emailInput.textShadow || "none",
          textAlign:
            emailInput.focusedtextAlign || emailInput.textAlign || "left",
          verticalAlign:
            emailInput.focusedverticalAlign ||
            emailInput.verticalAlign ||
            "baseline",
          textDecoration:
            emailInput.focusedtextDecoration ||
            emailInput.textDecoration ||
            "none",
          textTransform:
            emailInput.focusedtextTransform ||
            emailInput.textTransform ||
            "none",
          letterSpacing:
            emailInput.focusedletterSpacing ||
            emailInput.letterSpacing ||
            "normal",
          wordSpacing:
            emailInput.focusedwordSpacing || emailInput.wordSpacing || "normal",
          textIndent:
            emailInput.focusedtextIndent || emailInput.textIndent || "0",
          whiteSpace:
            emailInput.focusedwhiteSpace || emailInput.whiteSpace || "normal",
          textOverflow:
            emailInput.focusedtextOverflow || emailInput.textOverflow || "clip",
          direction:
            emailInput.focuseddirection || emailInput.direction || "ltr",
          unicodeBidi:
            emailInput.focusedunicodeBidi || emailInput.unicodeBidi || "normal",
          writingMode:
            emailInput.focusedwritingMode ||
            emailInput.writingMode ||
            "horizontal-tb",

          cursor: emailInput.focusedcursor || emailInput.cursor || "default",
          transform:
            emailInput.focusedtransform || emailInput.transform || "none",
          transition:
            emailInput.focusedtransition || emailInput.transition || "none",
        }
      : {};
  const hoverStyles =
    isDivHovered && emailInput.pseudoClass === "hover"
      ? {
          width: emailInput.hoveredwidth || emailInput.width || "200px",
          height: emailInput.hoveredheight || emailInput.height || "auto",

          padding: emailInput.hoveredpadding || emailInput.padding || "0",
          paddingTop:
            emailInput.hoveredpaddingTop || emailInput.hoveredpadding || "0",
          paddingRight:
            emailInput.hoveredpaddingRight || emailInput.hoveredpadding || "0",
          paddingBottom:
            emailInput.hoveredpaddingBottom || emailInput.hoveredpadding || "0",
          paddingLeft:
            emailInput.hoveredpaddingLeft || emailInput.hoveredpadding || "0",
          margin: emailInput.hoveredmargin || emailInput.margin || "0px",
          marginTop:
            emailInput.hoveredmarginTop || emailInput.hoveredmargin || "0px",
          marginRight:
            emailInput.hoveredmarginRight || emailInput.hoveredmargin || "0px",
          marginBottom:
            emailInput.hoveredmarginBottom || emailInput.hoveredmargin || "0px",
          marginLeft:
            emailInput.hoveredmarginLeft || emailInput.hoveredmargin || "10px",

          borderTop:
            emailInput.hoveredborderTop ||
            emailInput.hoveredborder ||
            emailInput.border ||
            "1px solid #000000",
          borderRight:
            emailInput.hoveredborderRight ||
            emailInput.hoveredborder ||
            emailInput.border ||
            "1px solid #000000",
          borderBottom:
            emailInput.hoveredborderBottom ||
            emailInput.hoveredborder ||
            emailInput.border ||
            "1px solid #000000",
          borderLeft:
            emailInput.hoveredborderLeft ||
            emailInput.hoveredborder ||
            emailInput.border ||
            "1px solid #000000",
          borderSapcing:
            emailInput.hoveredborderSpacing ||
            emailInput.borderSpacing ||
            "0px",
          borderCollapse:
            emailInput.hoveredborderCollapse ||
            emailInput.borderCollapse ||
            "0px",
          borderRadius:
            emailInput.hoveredborderRadius || emailInput.borderRadius || "0",
          outline: emailInput.hoveredoutline || emailInput.outline || "none",

          position:
            emailInput.hoveredposition || emailInput.position || "relative",
          top: emailInput.hoveredtop || emailInput.top || "auto",
          right: emailInput.hoveredright || emailInput.right || "auto",
          bottom: emailInput.hoveredbottom || emailInput.bottom || "auto",
          left: emailInput.hoveredleft || emailInput.left || "auto",
          zIndex: emailInput.hoveredzIndex || emailInput.zIndex || "auto",

          color: emailInput.hoveredcolor || emailInput.color || "#000000",
          backgroundColor:
            emailInput.hoveredbackgroundColor ||
            emailInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (emailInput.hoveredbackgroundImage) {
              if (emailInput.hoveredbackgroundImage.startsWith("./")) {
                const imageName = emailInput.hoveredbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${emailInput.hoveredbackgroundImage})`;
            }
            if (emailInput.backgroundImage) {
              if (emailInput.backgroundImage.startsWith("./")) {
                const imageName = emailInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${emailInput.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            emailInput.hoveredbackgroundPosition ||
            emailInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            emailInput.hoveredbackgroundSize ||
            emailInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            emailInput.hoveredbackgroundRepeat ||
            emailInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            emailInput.hoveredbackgroundAttachment ||
            emailInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            emailInput.hoveredboxShadow || emailInput.boxShadow || "none",
          opacity: emailInput.hoveredOpacity || emailInput.opacity || 1,
          display: emailInput.hovereddisplay || emailInput.display || "inline",

          fontFamily:
            emailInput.hoveredfontFamily || emailInput.fontFamily || "inherit",
          fontSize:
            emailInput.hoveredfontSize || emailInput.fontSize || "inherit",
          fontWeight:
            emailInput.hoveredfontWeight || emailInput.fontWeight || "normal",
          fontStyle:
            emailInput.hoveredfontStyle || emailInput.fontStyle || "normal",
          fontVariant:
            emailInput.hoveredfontVariant || emailInput.fontVariant || "normal",
          lineHeight:
            emailInput.hoveredlineHeight || emailInput.lineHeight || "normal",
          textShadow:
            emailInput.hoveredtextShadow || emailInput.textShadow || "none",
          textAlign:
            emailInput.hoveredtextAlign || emailInput.textAlign || "left",
          verticalAlign:
            emailInput.hoveredverticalAlign ||
            emailInput.verticalAlign ||
            "baseline",
          textDecoration:
            emailInput.hoveredtextDecoration ||
            emailInput.textDecoration ||
            "none",
          textTransform:
            emailInput.hoveredtextTransform ||
            emailInput.textTransform ||
            "none",
          letterSpacing:
            emailInput.hoveredletterSpacing ||
            emailInput.letterSpacing ||
            "normal",
          wordSpacing:
            emailInput.hoveredwordSpacing || emailInput.wordSpacing || "normal",
          textIndent:
            emailInput.hoveredtextIndent || emailInput.textIndent || "0",
          whiteSpace:
            emailInput.hoveredwhiteSpace || emailInput.whiteSpace || "normal",
          textOverflow:
            emailInput.hoveredtextOverflow || emailInput.textOverflow || "clip",
          direction:
            emailInput.hovereddirection || emailInput.direction || "ltr",
          unicodeBidi:
            emailInput.hoveredunicodeBidi || emailInput.unicodeBidi || "normal",
          writingMode:
            emailInput.hoveredwritingMode ||
            emailInput.writingMode ||
            "horizontal-tb",

          cursor: emailInput.hoveredcursor || emailInput.cursor || "default",
          transform:
            emailInput.hoveredtransform || emailInput.transform || "none",
          transition:
            emailInput.hoveredtransition || emailInput.transition || "none",
        }
      : {};
  const activeStyles =
    isDivActive && emailInput.pseudoClass === "active"
      ? {
          width: emailInput.activatedwidth || emailInput.width || "200px",
          height: emailInput.activatedheight || emailInput.height || "auto",

          padding: emailInput.activatedpadding || emailInput.padding || "0",
          paddingTop:
            emailInput.activatedpaddingTop ||
            emailInput.activatedpadding ||
            "0",
          paddingRight:
            emailInput.activatedpaddingRight ||
            emailInput.activatedpadding ||
            "0",
          paddingBottom:
            emailInput.activatedpaddingBottom ||
            emailInput.activatedpadding ||
            "0",
          paddingLeft:
            emailInput.activatedpaddingLeft ||
            emailInput.activatedpadding ||
            "0",
          margin: emailInput.activatedmargin || emailInput.margin || "0px",
          marginTop:
            emailInput.activatedmarginTop ||
            emailInput.activatedmargin ||
            "0px",
          marginRight:
            emailInput.activatedmarginRight ||
            emailInput.activatedmargin ||
            "0px",
          marginBottom:
            emailInput.activatedmarginBottom ||
            emailInput.activatedmargin ||
            "0px",
          marginLeft:
            emailInput.activatedmarginLeft ||
            emailInput.activatedmargin ||
            "10px",

          borderTop:
            emailInput.activatedborderTop ||
            emailInput.activatedborder ||
            emailInput.border ||
            "1px solid #000000",
          borderRight:
            emailInput.activatedborderRight ||
            emailInput.activatedborder ||
            emailInput.border ||
            "1px solid #000000",
          borderBottom:
            emailInput.activatedborderBottom ||
            emailInput.activatedborder ||
            emailInput.border ||
            "1px solid #000000",
          borderLeft:
            emailInput.activatedborderLeft ||
            emailInput.activatedborder ||
            emailInput.border ||
            "1px solid #000000",
          borderSapcing:
            emailInput.activatedborderSpacing ||
            emailInput.borderSpacing ||
            "0px",
          borderCollapse:
            emailInput.activatedborderCollapse ||
            emailInput.borderCollapse ||
            "0px",
          borderRadius:
            emailInput.activatedborderRadius || emailInput.borderRadius || "0",
          outline: emailInput.activatedoutline || emailInput.outline || "none",

          position:
            emailInput.activatedposition || emailInput.position || "relative",
          top: emailInput.activatedtop || emailInput.top || "auto",
          right: emailInput.activatedright || emailInput.right || "auto",
          bottom: emailInput.activatedbottom || emailInput.bottom || "auto",
          left: emailInput.activatedleft || emailInput.left || "auto",
          zIndex: emailInput.activatedzIndex || emailInput.zIndex || "auto",

          color: emailInput.activatedcolor || emailInput.color || "#000000",
          backgroundColor:
            emailInput.activatedbackgroundColor ||
            emailInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (emailInput.activatedbackgroundImage) {
              if (emailInput.activatedbackgroundImage.startsWith("./")) {
                const imageName = emailInput.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${emailInput.activatedbackgroundImage})`;
            }
            if (emailInput.backgroundImage) {
              if (emailInput.backgroundImage.startsWith("./")) {
                const imageName = emailInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${emailInput.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            emailInput.activatedbackgroundPosition ||
            emailInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            emailInput.activatedbackgroundSize ||
            emailInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            emailInput.activatedbackgroundRepeat ||
            emailInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            emailInput.activatedbackgroundAttachment ||
            emailInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            emailInput.activatedboxShadow || emailInput.boxShadow || "none",
          opacity: emailInput.activatedOpacity || emailInput.opacity || 1,
          display:
            emailInput.activateddisplay || emailInput.display || "inline",

          fontFamily:
            emailInput.activatedfontFamily ||
            emailInput.fontFamily ||
            "inherit",
          fontSize:
            emailInput.activatedfontSize || emailInput.fontSize || "inherit",
          fontWeight:
            emailInput.activatedfontWeight || emailInput.fontWeight || "normal",
          fontStyle:
            emailInput.activatedfontStyle || emailInput.fontStyle || "normal",
          fontVariant:
            emailInput.activatedfontVariant ||
            emailInput.fontVariant ||
            "normal",
          lineHeight:
            emailInput.activatedlineHeight || emailInput.lineHeight || "normal",
          textShadow:
            emailInput.activatedtextShadow || emailInput.textShadow || "none",
          textAlign:
            emailInput.activatedtextAlign || emailInput.textAlign || "left",
          verticalAlign:
            emailInput.activatedverticalAlign ||
            emailInput.verticalAlign ||
            "baseline",
          textDecoration:
            emailInput.activatedtextDecoration ||
            emailInput.textDecoration ||
            "none",
          textTransform:
            emailInput.activatedtextTransform ||
            emailInput.textTransform ||
            "none",
          letterSpacing:
            emailInput.activatedletterSpacing ||
            emailInput.letterSpacing ||
            "normal",
          wordSpacing:
            emailInput.activatedwordSpacing ||
            emailInput.wordSpacing ||
            "normal",
          textIndent:
            emailInput.activatedtextIndent || emailInput.textIndent || "0",
          whiteSpace:
            emailInput.activatedwhiteSpace || emailInput.whiteSpace || "normal",
          textOverflow:
            emailInput.activatedtextOverflow ||
            emailInput.textOverflow ||
            "clip",
          direction:
            emailInput.activateddirection || emailInput.direction || "ltr",
          unicodeBidi:
            emailInput.activatedunicodeBidi ||
            emailInput.unicodeBidi ||
            "normal",
          writingMode:
            emailInput.activatedwritingMode ||
            emailInput.writingMode ||
            "horizontal-tb",

          cursor: emailInput.activatedcursor || emailInput.cursor || "default",
          transform:
            emailInput.activatedtransform || emailInput.transform || "none",
          transition:
            emailInput.activatedtransition || emailInput.transition || "none",
        }
      : {};

  const inputStyle = {
    width: emailInput.width || "200px",
    height: emailInput.height || "auto",

    margin: emailInput.margin || "0px",
    marginTop: emailInput.marginTop || emailInput.margin || "0",
    marginRight: emailInput.marginRight || emailInput.margin || "0px",
    marginBottom: emailInput.marginBottom || emailInput.margin || "0",
    marginLeft: emailInput.marginLeft || emailInput.margin || "10px",
    padding: emailInput.padding || "0px",
    paddingTop: emailInput.paddingTop || emailInput.padding || "0",
    paddingRight: emailInput.paddingRight || emailInput.padding || "0",
    paddingBottom: emailInput.paddingBottom || emailInput.padding || "0",
    paddingLeft: emailInput.paddingLeft || emailInput.padding || "0",

    borderTop: isHovered
      ? "1px dashed #555"
      : emailInput.borderTop || emailInput.border || "1px solid #000000",
    borderRight: isHovered
      ? "1px dashed #555"
      : emailInput.borderRight || emailInput.border || "1px solid #000000",
    borderBottom: isHovered
      ? "1px dashed #555"
      : emailInput.borderBottom || emailInput.border || "1px solid #000000",
    borderLeft: isHovered
      ? "1px dashed #555"
      : emailInput.borderLeft || emailInput.border || "1px solid #000000",

    borderSapcing: emailInput.borderSpacing || "0px",
    borderCollapse: emailInput.borderCollapse || "0px",
    borderRadius: emailInput.borderRadius || "0",
    outline: emailInput.outline || "none",

    position: emailInput.position || "static",
    top: emailInput.top || "auto",
    right: emailInput.right || "auto",
    bottom: emailInput.bottom || "auto",
    left: emailInput.left || "auto",
    zIndex: emailInput.zIndex || "auto",

    color: emailInput.color || "#000000",
    backgroundColor: emailInput.backgroundColor || "#ffffff",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),
    backgroundPosition:
      emailInput.focusedbackgroundPosition ||
      emailInput.backgroundPosition ||
      "0% 0%",
    backgroundSize:
      emailInput.focusedbackgroundSize || emailInput.backgroundSize || "auto",
    backgroundRepeat:
      emailInput.focusedbackgroundRepeat ||
      emailInput.backgroundRepeat ||
      "repeat",
    backgroundAttachment:
      emailInput.focusedbackgroundAttachment ||
      emailInput.backgroundAttachment ||
      "scroll",

    fontSize: emailInput.fontSize || "inherit",
    fontFamily: emailInput.fontFamily || "inherit",
    fontWeight: emailInput.fontWeight || "normal",
    fontStyle: emailInput.fontStyle || "normal",
    fontVariant: emailInput.fontVariant || "normal",
    lineHeight: emailInput.lineHeight || "normal",
    textAlign: emailInput.textAlign || "left",
    textDecoration: emailInput.textDecoration || "none",
    textTransform: emailInput.textTransform || "none",
    textShadow: emailInput.textShadow || "none",
    verticalAlign: emailInput.verticalAlign || "baseline",
    letterSpacing: emailInput.letterSpacing || "normal",
    wordSpacing: emailInput.wordSpacing || "normal",
    textIndent: emailInput.textIndent || "0",
    whiteSpace: emailInput.whiteSpace || "normal",
    textOverflow: emailInput.textOverflow || "clip",
    direction: emailInput.direction || "ltr",
    unicodeBidi: emailInput.unicodeBidi || "normal",
    writingMode: emailInput.writingMode || "horizontal-tb",

    opacity: emailInput.opacity || "1",
    display: emailInput.display || "inline",
    cursor: emailInput.cursor || "auto",

    transform: emailInput.transform || "none",
    transition: emailInput.transition || "none",

    scale: isHovered ? "1.01" : "1",
    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const labelStyle = {
    margin: emailInput.labelmargin || "0px",
    marginTop: emailInput.labelmarginTop || emailInput.labelmargin || "0",
    marginRight: emailInput.labelmarginRight || emailInput.labelmargin || "0px",
    marginBottom: emailInput.labelmarginBottom || emailInput.labelmargin || "0",
    marginLeft: emailInput.labelmarginLeft || emailInput.labelmargin || "0",
    padding: emailInput.labelpadding || "0px",
    paddingTop: emailInput.labelpaddingTop || emailInput.labelpadding || "0",
    paddingRight:
      emailInput.labelpaddingRight || emailInput.labelpadding || "0",
    paddingBottom:
      emailInput.labelpaddingBottom || emailInput.labelpadding || "0",
    paddingLeft: emailInput.labelpaddingLeft || emailInput.labelpadding || "0",

    borderTop: isHovered
      ? "1px dashed #555"
      : emailInput.labelborderTop || emailInput.labelborder || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : emailInput.labelborderRight || emailInput.labelborder || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : emailInput.labelborderBottom || emailInput.labelborder || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : emailInput.labelborderLeft || emailInput.labelborder || "none",

    borderSapcing: emailInput.labelborderSpacing || "0px",
    borderCollapse: emailInput.labelborderCollapse || "0px",
    borderRadius: emailInput.labelborderRadius || "0",
    outline: emailInput.labeloutline || "none",

    position: emailInput.labelposition || "static",
    top: emailInput.labeltop || "auto",
    right: emailInput.labelright || "auto",
    bottom: emailInput.labelbottom || "auto",
    left: emailInput.labelleft || "auto",
    zIndex: emailInput.labelzIndex || "auto",

    color: emailInput.labelcolor || "#000000",
    backgroundColor: emailInput.labelbackgroundColor || "#ffffff",
    backgroundImage: backgroundImagelabelUrl
      ? `url(${backgroundImagelabelUrl})`
      : labelconstructGradientString(),
    backgroundPosition:
      emailInput.labelbackgroundPosition ||
      emailInput.labelbackgroundPosition ||
      "0% 0%",
    backgroundSize:
      emailInput.labelbackgroundSize ||
      emailInput.labelbackgroundSize ||
      "auto",
    backgroundRepeat:
      emailInput.labelbackgroundRepeat ||
      emailInput.labelbackgroundRepeat ||
      "repeat",
    backgroundAttachment:
      emailInput.labelbackgroundAttachment ||
      emailInput.labelbackgroundAttachment ||
      "scroll",

    fontSize: emailInput.labelfontSize || "inherit",
    fontFamily: emailInput.labelfontFamily || "inherit",
    fontWeight: emailInput.labelfontWeight || "normal",
    fontStyle: emailInput.labelfontStyle || "normal",
    fontVariant: emailInput.labelfontVariant || "normal",
    lineHeight: emailInput.labellineHeight || "normal",
    textAlign: emailInput.labeltextAlign || "left",
    textDecoration: emailInput.labeltextDecoration || "none",
    textTransform: emailInput.labeltextTransform || "none",
    textShadow: emailInput.labeltextShadow || "none",
    verticalAlign: emailInput.labelverticalAlign || "baseline",
    letterSpacing: emailInput.labelletterSpacing || "normal",
    wordSpacing: emailInput.labelwordSpacing || "normal",
    textIndent: emailInput.labeltextIndent || "0",
    whiteSpace: emailInput.labelwhiteSpace || "normal",
    textOverflow: emailInput.labeltextOverflow || "clip",
    direction: emailInput.labeldirection || "ltr",
    unicodeBidi: emailInput.labelunicodeBidi || "normal",
    writingMode: emailInput.labelwritingMode || "horizontal-tb",

    opacity: emailInput.labelopacity || "1",
    display: emailInput.display || "inline",
    cursor: emailInput.cursor || "auto",

    transform: emailInput.transform || "none",
    transition: emailInput.transition || "none",
  };

  return (
    <>
      <label style={labelStyle}>{emailInput.label || "Email Label"}</label>
      <input
        type="email"
        value={emailInput.value}
        placeholder={emailInput.placeholder || "Enter your email"}
        style={inputStyle}
        pattern={
          emailInput.pattern || "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"
        }
        onMouseEnter={() => setIsDivHovered(true)}
        onMouseLeave={() => setIsDivHovered(false)}
        onFocus={() => setIsDivFocused(true)}
        onBlur={() => setIsDivFocused(false)}
        onMouseDown={() => setIsDivActive(true)}
        onMouseUp={() => setIsDivActive(false)}
      />
    </>
  );
};

export default EmailInputComponent;
